import React, { useEffect, useState } from "react";
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { useAuthenticator } from '@aws-amplify/ui-react';
import LoginNavBar from '../components/ui/LoginNavbar';
import { Card, Flex, Button, Text, Heading } from "@aws-amplify/ui-react";
// import { View } from '@aws-amplify/ui-react';
// import {
//   useTheme
// } from '@aws-amplify/ui-react';

export function Layout() {
  const { route } = useAuthenticator((context) => [context.route]);
  const { user } = useAuthenticator((context) => [context.user]);
  const [selectedRole, setSelectedRole] = useState(null);
  // const { tokens } = useTheme();
  let location = useLocation();
  const navigate = useNavigate();

  console.log(user?.attributes?.["custom:user_type"])

  useEffect(() => {

    // console.log("Route:", route);
    // console.log("User attributes:", user?.attributes);
    // console.log("this is to:", location.pathname);
    
    if (route === 'authenticated' ) {
      const itemId = location.state?.itemId; // Extract itemId from location state if available
      // console.log("Item ID:", itemId);
      // if (route === 'authenticated' && location.pathname === '/home') {
      const userType = user?.attributes?.["custom:user_type"];
      // console.log("User type:", userType);
      // console.log(location.pathname )

      if  (location.pathname === '/home' || location.pathname === '/home/distributor' || location.pathname === '/home/producer' || location.pathname === '/signup-distributor' || location.pathname==='/signup-producer') {

        if (userType === "producer"  ) {
          console.log("Redirecting to /home/producer");
          navigate("/home/producer", {
            replace: true,
          });

        } else if (userType === "distributor") {
          console.log("Redirecting to /home/distributor");
          navigate("/home/distributor", { replace: true });
        } else {
          console.warn("User type not recognized, redirecting to default.");
          navigate('/noMatch', { replace: true }); // Default or safe route
        }
        
    } else {
      console.warn("User type not recognized, redirecting to default.");
      navigate(location.pathname, { replace: true , state: itemId ? { itemId } : undefined}); // Default or safe route
    }
    }
  }, [route, user, location.pathname, location.state?.itemId, navigate]);

  const handleRoleSelection = (role) => {
    setSelectedRole(role);
    if (role === 'Distributor') {
      navigate('/signup-distributor');
    } else if (role === 'Producer') {
      navigate('/signup-producer');
    }
  };

  const initialCards = [
    {
      title: 'Distributor',
      description: 'Elevate your portfolio with exclusive Italian wines and spirits. Captivate clients with handcrafted, premium products that stand apart.',
      onClick: () => setVisibleCards('distributor'),
    },
    {
      title: 'Producer',
      description: 'Showcase your unique products globally. Let Merum handle compliance and branding while you focus on your craft.',
      onClick: () => setVisibleCards('producer'),
    },
  ];
  
  const distributorCards = [
    {
      title: 'Sample',
      description: 'Discover the best options for your portfolio. Start sampling today to explore, discover, and select exceptional products for your business needs.',
      onClick: () => handleRoleSelection('Distributor'),
    },
    {
      title: 'Order (coming soon)*',
      description: 'Discover the finest selections to elevate your portfolio. Place your orders today to explore, evaluate, and curate exceptional products tailored to your business needs, ensuring quality and exclusivity for your customers.',
      // onClick: () => (window.location.href = 'https://analytics.merum.club/'),
    },
    {
      title: 'AI Sales Agent (coming soon)*',
      description: 'Harness the power of AI to revolutionize your distribution strategy. Optimize inventory management, enhance decision-making, and maximize profitability with cutting-edge insights tailored to your business needs.',
      // onClick: () => (window.location.href = 'https://ai.merum.club/'),
    },
    // {
    //   title: 'POS Analytics Dashboard',
    //   description: 'Access powerful analytics for Point of Sales across the US. Uncover trends and insights to refine your distribution strategy and maximize performance.',
    //   onClick: () => (window.location.href = 'https://analytics.merum.club/'),
    // },
  ];
  
  const producerCards = [
    {
      title: 'Sample',
      description: 'Elevate your brand\'s visibility. Join our sampling program to showcase your craft to distributors around the world.',
      onClick: () => handleRoleSelection('Producer'),
    },
    {
      title: 'Sell*',
      description: 'Access tools designed to empower producers. Expand globally and bring your exceptional wines and spirits to the forefront.',
      onClick: () => (window.location.href = 'https://producer.merum.club/'),
    },
    {
      title: 'AI agent (coming soon)*',
      description: 'Harness AI-driven insights to optimize production, enhance efficiency, and refine craftsmanship. Leverage data-driven marketing tools to identify trends, target the right audience, and expand your market reach with precision.',
      // onClick: () => (window.location.href = 'https://ai.merum.club/'),
    },
  ];

  const [visibleCards, setVisibleCards] = useState('initial'); // Manage visible cards state

  const renderCards = (cards) => {
    return (
      <Flex
        direction="row"
        justifyContent="center"
        wrap="wrap"
        gap="20px"
        style={{
          overflowX: "auto",
          padding: "20px",
        }}
      >
        {cards.map((item, index) => (
          <div
            key={index}
            className="card"
            style={{
              transition: "transform 0.3s ease, box-shadow 0.3s ease",
              transform: "scale(1)",
              maxWidth: "350px",
              flex: "1 1 calc(33.333% - 20px)", // Responsive sizing
              minWidth: "300px",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "scale(1.05)";
              e.currentTarget.style.boxShadow = "0 10px 20px rgba(0, 0, 0, 0.2)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "scale(1)";
              e.currentTarget.style.boxShadow = "none";
            }}
          >
            <Card
              variation="elevated"
              width="100%"
              height="100%" // Set to fill parent height
              padding="20px"
              borderRadius="10px"
              backgroundColor="rgba(255, 255, 255, 0.8)"
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between", // Ensures even spacing
                height: "100%", // Match all cards' height
              }}
            >
              <Heading
                level={4}
                className="card-title"
                style={{
                  marginBottom: "15px", // Space between title and text
                }}
              >
                {item.title}
              </Heading>
              <Text
                className="card-description"
                style={{
                  marginTop: "10px", // Consistent spacing from the title
                  marginBottom: "20px", // Space between text and button
                }}
              >
                {item.description}
              </Text>
              {item.onClick && (
                <Button
                  className="card-button"
                  variation="primary"
                  onClick={item.onClick}
                  // backgroundColor={"black"}
                  width="100%"
                  style={{
                    height: "45px", // Uniform button height
                  }}
                >
                  Get Started
                </Button>
              )}
            </Card>
          </div>
        ))}
      </Flex>
      
    );
  };
  
  
  
  
  
  
  return (
    <>
      <LoginNavBar />
      {!user && !selectedRole && (
         
         
         <div
         className="main-container"
         style={{
           backgroundSize: "cover",
           backgroundPosition: "center",
           height: "100vh",
           padding: "80px 120px", // General padding for cleaner look
           boxSizing: "border-box",
           display: "flex",
           flexDirection: "column",
           justifyContent: "space-between",
         }}
       >
         <div
           style={{
             textAlign: "center", // Center align for a balanced layout
             marginBottom: "40px", // Space below the header
             padding: "10px", // Inner spacing for layout clarity
           }}
         >
           <h1
             style={{
               fontFamily: "'Varela Round', sans-serif",
               fontSize: "32px",
               marginBottom: "15px",
               color: "black", // Unified modern grey for titles
               lineHeight: "1.2",
             }}
           >
             Welcome to Merum Marketplace
           </h1>
           <p
             style={{
               fontFamily: "'Varela Round', sans-serif",
               fontSize: "18px",
               fontWeight: "400",
               color: "#666", // Consistent grey for body text
               lineHeight: "1.6",
               margin: "0 auto", // Center content
               maxWidth: "600px", // Constrain width for better focus
             }}
           >
             Discover a world of exclusive Italian wines and spirits. Choose your path and start the journey with us!
           </p>
         </div>
       
         <Flex direction="column" alignItems="center" gap="20px">
           {/* Render the appropriate cards */}
           {visibleCards === "initial" && (
             <div
               style={{
                 display: "grid",
                 gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", // Responsive card layout
                 gap: "20px",
                 width: "100%",
               }}
             >
               {renderCards(initialCards)}
             </div>
           )}
           {visibleCards === "distributor" && (
             <>
               <div
                 style={{
                   display: "grid",
                   gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                   gap: "20px",
                   width: "100%",
                 }}
               >
                 {renderCards(distributorCards)}
               </div>
               <Flex justifyContent="center" marginTop="20px">
                 <Button
                   variation="primary"
                   onClick={() => setVisibleCards("initial")}
                   style={{
                     height: "45px",
                     padding: "12px 24px",
                     fontSize: "16px",
                     backgroundColor: "black", // Matching grey for buttons
                     color: "#fff",
                     borderRadius: "6px",
                     border: "none",
                     cursor: "pointer",
                   }}
                 >
                   Home
                 </Button>
               </Flex>
             </>
           )}
           {visibleCards === "producer" && (
             <>
               <div
                 style={{
                   display: "grid",
                   gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                   gap: "20px",
                   width: "100%",
                 }}
               >
                 {renderCards(producerCards)}
               </div>
               <Flex justifyContent="center" marginTop="20px">
                 <Button
                   variation="primary"
                   onClick={() => setVisibleCards("initial")}
                   style={{
                     height: "45px",
                     padding: "12px 24px",
                     fontSize: "16px",
                     backgroundColor: "black", // Matching grey for buttons
                     color: "#fff",
                     borderRadius: "6px",
                     border: "none",
                     cursor: "pointer",
                   }}
                 >
                   Home
                 </Button>
               </Flex>
             </>
           )}
         </Flex>
          

          <>
          <br></br>
          <h3 style={{ color: "black" }}>
          * You can schedule a call with our team here:{" "}
          <a
          target="_blank"
          rel="noreferrer"
          href="https://calendly.com/merum-francesco/30min"
          style={{ color: "#2d7dd2", textDecoration: "none" }}
          >
          Schedule a call
          </a>.
          </h3>
          </>

         <Text style={{ fontSize: "1em", marginBottom: "1.5em" }}>
            
          </Text>
       </div>
       

        


          

      )}
    
    <Flex 
      justifyContent="center"
    >
      <Outlet />
    </Flex>
    </>
  );
}
